import axios from 'axios' //引用
import url from "./api";
import store from '../store/index'
// import Router from '../router' //路由引用，若是在文件内有涉及，就要进行引用


// 获取token信息
export function getToken() {
  let token=sessionStorage.getItem("token")
  if(token){//有token信息
    return token
  }else{//没有登录信息,返回 '' 前端不判断
    return ''
  }
}
// 存储 token 信息
export function tokenLogin(LToken) {
  sessionStorage.setItem('token',LToken.token)
  sessionStorage.setItem('refresh_token',LToken.refresh_token)
  // 刷新时间存储处理成过期时间戳，到时候比对那当前时间进行对比 
  // let resetTime=Date.now()+(30000+300)
  let resetTime=Date.now()+(Number(LToken.resetTime))
  // let resetTime=Date.now()+(Number(LToken.resetTime)-120000)
  sessionStorage.setItem('resetTime',resetTime)
  sessionStorage.setItem('access_time',LToken.resetTime)
}
// 删除 token信息
export function DelToken() {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("refresh_token");
  sessionStorage.removeItem("resetTime");
  sessionStorage.removeItem("access_time");
}
// 删除 用户信息
export function DelUserInfo() {
  store.dispatch('DelAuserInfo')
  store.dispatch('DelABuserInfo')
  sessionStorage.removeItem('logi');
  sessionStorage.removeItem('bkL');
}
// token 失效刷新 token
export async function refreshToken() {
  try{
    let refresh_token=sessionStorage.getItem("refresh_token")
    // 使用 ref_token 刷新token
    let result=await axios.post(url.baseUrl+'/api/token/refresh/',{refresh:refresh_token}) 
    // console.log(result,222);
    if(result.data.access){
      // 获取成功，存储token信息 return token
      tokenLogin({
        token:result.data.access,
        resetTime:sessionStorage.getItem("access_time"),
        refresh_token:sessionStorage.getItem("refresh_token"),
      })
      return result.data.access
    }else{
      //获取失败 删除token信息和身份信息 userInfo/buserInfo  
      DelToken()
      return ''
    }
  }catch (error) {
    //获取失败 删除token信息和身份信息
    DelToken()
    return ''
  }
}


// WEBPACK FOOTER //
// ./src/common/operateToken.js